<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [canGoBack]="true"
      [title]="'Notification Settings'"
      [customBack]="'notification-center'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">

    @if (errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }

    @if (loaded) {
      <tidy-row [align]="'center'">
        <tidy-text [body]="'Customize notifications the way you want.'" />
      </tidy-row>
      <tidy-row>
        <form [formGroup]="searchForm" novalidate action="#">
          <tidy-search-input
            formControlName="search"
            [placeholder]="'Search'"
            [icon]="'assets/svg/search.svg'" />
        </form>
      </tidy-row>
      @for (notification of filteredNotificationSettings; track notification; let i = $index) {
        <tidy-row class="no-padding">
          <tidy-card>
            <tidy-row>
              <tidy-text
                [body]="notification?.title" />
              @if (notification?.title === 'Message Received') {
                <div style="display: flex; align-items: center;">
                  <tidy-text
                    [helper]="smsForwardingText.helper"
                    style="margin-right: 5px" />
                  <tidy-image
                    src="assets/img/help-circle-outline.svg"
                    class="body-size"
                    [matTooltip]="smsForwardingText.tooltip | translate"
                    [matTooltipPosition]="'below'"
                    matTooltipClass="menu-item-tooltip below"
                    style="opacity: 0.5" />
                </div>
              }
            </tidy-row>
            <ion-accordion-group>
              @for (channel of notification.channels; track channel) {
                <ion-accordion class="custom-accordion">
                  <ion-item slot="header" (click)="openChannelSettings(channel)">
                    <tidy-checkbox
                      (click)="toggleChannel($event, channel, notification)"
                      class="custom-checkbox"
                      [(checked)]="channel.checked"
                      [initValue]="channel.checked"
                      [watchOnChange]="true"
                      [items]="[{viewValue: '', value: ''}]" />
                    <tidy-text
                      [body]="channel.name | titlecase"
                      style="margin-left: 10px" />
                  </ion-item>
                  <div slot="content">
                    @if (notification.allowsTimeRangeConfig || true) {
                      @if (channel.isOpened) {
                        <ion-accordion-group>
                          @for (formGrp of channel.timeRangeForms; track formGrp; let timeRangeIndex = $index) {
                            <ion-accordion [disabled]="!channel.checked">
                              <ion-item
                                slot="header"
                                (click)="onAccordionChange(i, timeRangeIndex)">
                                <tidy-checkbox
                                  (click)="toggleDay($event, notification, channel, formGrp)"
                                  class="custom-checkbox"
                                  [(checked)]="formGrp.dayForm.controls.checked.value"
                                  [initValue]="formGrp.dayForm.controls.checked.value"
                                  [watchOnChange]="true"
                                  [items]="[{viewValue: '', value: ''}]" />
                                <tidy-text
                                  [body]="formGrp.dayForm.controls.day.value  | titlecase"
                                  style="margin-left: 10px" />
                              </ion-item>
                              @if (expandedIndex === i + '-' + timeRangeIndex) {
                                <div class="ion-padding" slot="content">
                                  @for (control of formGrp.timeRangeForm.controls; track control; let last = $last; let controlIndex = $index) {
                                    <tidy-two-column-row
                                      [formGroup]="control"
                                      style="padding-bottom: 1rem">
                                      <tidy-select
                                        style="max-width: 40%; margin: 0"
                                        [icon]="'assets/svg/time-outline.svg'"
                                        [label]="'Earliest'"
                                        [form]="control.controls.start_time"
                                        formControlName="start_time"
                                        errorMessage="Select a valid time"
                                        [submitted]="true"
                                        (optionChange)="updateValidity()"
                                        [items]="timeOpts" />
                                      <span
                                        style="
                                          align-self: center;
                                          justify-content: space-around;
                                          max-width: 10%;
                                        "
                                        >-</span
                                        >
                                        <tidy-select
                                          style="max-width: 40%; margin-right: 10px"
                                          [icon]="'assets/svg/time-outline.svg'"
                                          [label]="'Latest'"
                                          [form]="control.controls.end_time"
                                          formControlName="end_time"
                                          errorMessage="Select a valid time"
                                          [submitted]="true"
                                          (optionChange)="updateValidity()"
                                          [items]="endTimes(control.controls.start_time.value)" />
                                        <tidy-image
                                          (action)="removeTimeRange(formGrp.timeRangeForm, controlIndex)"
                                          src="assets/img/trash-icon-outline.svg"
                                          class="icon body-size"
                                        style="
                                          max-width: 16px;
                                          align-self: center;
                                        " />
                                      </tidy-two-column-row>
                                    }
                                    <tidy-row>
                                      <tidy-text
                                        [body]="'+ Add Time Restriction'"
                                        (action)="addTimeRange(formGrp.timeRangeForm)"
                                        class="link" />
                                    </tidy-row>
                                  </div>
                                }
                              </ion-accordion>
                            }
                          </ion-accordion-group>
                        }
                      }
                    </div>
                  </ion-accordion>
                }
              </ion-accordion-group>
            </tidy-card>
          </tidy-row>
        }
      }

      @if (!loaded) {
        @for (item of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]; track item) {
          <tidy-row>
            <tidy-card>
              <tidy-row>
                <ion-skeleton-text
                  [animated]="true"
                [style]="{ width: '100%', height: '22px', borderRadius: '8px' }" />
              </tidy-row>
              <tidy-row>
                <ion-skeleton-text
                  [animated]="true"
                [style]="{ width: '100%', height: '48px', borderRadius: '8px' }" />
              </tidy-row>
              <tidy-row>
                <ion-skeleton-text
                  [animated]="true"
                [style]="{ width: '100%', height: '48px', borderRadius: '8px' }" />
              </tidy-row>
            </tidy-card>
          </tidy-row>
        }
      }

    </tidy-wrapper>
  </ng-template>

  @if (!isRightSideContent) {
    <app-scroll-wrapper [templateContent]="content" />
  }

  @if (isRightSideContent) {
    <ion-content class="ion-content-right-column">
      <ng-container *ngTemplateOutlet="content" />
    </ion-content>
  }
